import * as React from 'react'
import { useMemo } from 'react'

import Typography from '@mui/material/Typography'

import { readableFieldType } from '@user/store/customFields'
import type { CustomField, CustomFieldOption } from '@sales-center/common'
import { useActions } from './useActions'
import { MoreButton, CustomFieldsIcon } from '@sales-center/components'
import type { OpenFormCallback } from '../CustomFieldForm'
import { CustomFieldCard } from './CustomFieldCard.styled'
import { CustomFieldText } from './CustomFieldText.styled'
import { CustomFieldName } from './CustomFieldName.styled'

export type CustomFieldListItemProps = {
  customField: CustomField
  customFieldOptions?: CustomFieldOption[]
  openForm: OpenFormCallback
  openDelete: (id: number) => void
  index: number
}

export function CustomFieldListItem(props: CustomFieldListItemProps) {
  const { customField, index } = props

  const { name, type } = customField

  const moreBtnOpts = useActions(props)

  const readableType = useMemo(() => readableFieldType(type), [type])

  return (
    <CustomFieldCard elevation={2}>
      <CustomFieldsIcon />

      <CustomFieldText>
        <CustomFieldName variant="subtitle1">{name}</CustomFieldName>
        <Typography variant="caption">{`Custom Field ${index} - ${readableType}`}</Typography>
      </CustomFieldText>

      <MoreButton
        options={moreBtnOpts}
        dataTestId={`customFieldMoreBtn-${customField.id}`}
      />
    </CustomFieldCard>
  )
}
